





































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import SetHubspotDealTrigger from './SetHubspotDealTrigger.coffee'

settings =
  name: 'SetHubspotDealTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [SetHubspotDealTrigger.trigger()]

    methods:
      modalData: ->
        basis: @modal.config.basis
        deal_id: @modal.config.deal_id

      hiChangeBasis: (basis) ->
        @modal.data.deal_id = null if basis isnt 'upfront_contract'

export default VueOptions.vue settings
